import { HandlebarsCache } from "../_helpers/HandlebarsCache";
import { BaseModel } from "../_models/Base";

import cssTemplate from '../../templates/stand_alone_video_widget_page/styles.hbs';

export default class VideoWidget extends BaseModel {
    /** @type {Author[]} */
    authors = null;
    banner_path = null;
    call_to_action_text = null;
    call_to_action_url = null;
    categories = null;
    company_name = null;
    css_link = null;
    featured_videos = null;
    feedback_enabled = null;
    header_text = null;
    logo_path = null;
    missing_cta_fallback = null;
    primary_color_hex = null;
    show_call_to_action = false;
    show_banner_tint = true;
    show_share_link = true;
    hide_last_name = false;
    hide_job_title = false;
    /** @type {TagType[]} */
    tags = null;
    /** @type {VideoWidgetPost[]} */
    videos = null;
    widget_bottom_distance = null;
    widget_enabled = null;
    widget_position = null;
    
    // Generated properties, not provided by json
    _cssInjected = false;
    _videoList = null;
    cdn = null;
    widget_code = null;
    constructor(jsonObj) {
        super();
        this.init(jsonObj);
    }

    injectCSS() {
        if(this._cssInjected) {
            return;
        }
        this._cssInjected = true;
        if(this.css_link) {
            let css_data = {
                primary_color_hex: this.primary_color_hex
            };
            const style = document.createElement("style")
            style.textContent = cssTemplate(css_data);
            document.head.appendChild(style)

        }
    }

    getVideoList() {
        if(this._videoList != null) {
            return this._videoList;
        }
        this._videoList = [];
        for(var i = 0;i < this.videos.length;i++) {
            let _video = this.videos[i];
            if(Array.isArray(_video.video_streams) && _video.video_streams.length > 0) {
                let textTracks = null;
                if(_video.video_subtitles != null) {
                    textTracks = [..._video.video_subtitles];
                }
                this._videoList.push({
                    sources: [..._video.video_streams],
                    video_id: _video.id,
                    poster:_video.thumbnail_link,
                    textTracks:textTracks,
                    video:this.videos[i]
                });
            }
        }
        return this._videoList;
    }

    getVideoById(id) {
        for(var i = 0;i < this.videos.length;i++) {
            if(this.videos[i].id == id) {
                return this.videos[i];
            }
        }
        return null;
    }

    getTagById(tagId, tagTypeId = null) {
        if(tagTypeId != null) {
            if(this.tags.hasOwnProperty(tagTypeId)) {
                for(var i = 0;i < this.tags[tagTypeId].tags_collection.length;i++) {
                    if(this.tags[tagTypeId].tags_collection[i].uuid == tagId) {
                        return this.tags[tagTypeId].tags_collection[i];
                    }
                }
            }
            return null;
        } else {
            for(var key in this.tags) {
                let _tag = this.getTagById(tagId, key);
                if(_tag != null) {
                    return _tag;
                }
            }
        }
        return null;
    }

    getTagByTagName(tagName) {
        for(var key in this.tags) {
            let _tagGroup = this.tags[key];
            for(var i = 0;i < _tagGroup.tags_collection.length;i++) {
                if(_tagGroup.tags_collection[i].tag_name == tagName) {
                    return _tagGroup.tags_collection[i];
                }
            }
        }
    }

    //#region Init Handlers
    initHandlers() {
        return {
            authors: VideoWidget._authorsInitHandler,
            tags: VideoWidget._tagsInitHandler,
            videos: VideoWidget._videosInitHandler
        }
    }

    static _authorsInitHandler(authors) {
        let newAuthors = [];
        if(Array.isArray(authors)) {
            for(var i = 0;i < authors.length;i++) {
                newAuthors.push(new Author(authors[i]));
            }
        }
        return newAuthors;
    }

    static _tagsInitHandler(tags) {
        let newTags = {};
        if(Array.isArray(tags)) {
            for(var i = 0;i < tags.length;i++) {
                let _tagType = new TagType(tags[i]);
                newTags[_tagType.uuid] = _tagType;
            }
        }
        return newTags;
    }

    static _videosInitHandler(videos, jsonObj) {
        let newVideos = [];
        if(Array.isArray(videos)) {
            for(var i = 0;i < videos.length;i++) {
                let _video = new VideoWidgetPost(videos[i]);

                // Change the tag_uuids into actual tags data
                let tempTags = this.tags;
                if(tempTags == null) {
                    tempTags = VideoWidget._tagsInitHandler(jsonObj['tags']);
                }
                _video.generateTagData(tempTags);
                newVideos.push(_video);
            }
        }
        return newVideos;
    }

    //#endregion

    //#region Static Init
    static async Init(widgetCode, cdn) {
        //#region What I'd like to do
        /*
        NOTE: fetch will get CORS errors, even though XMLHttpRequest doesn't. Makes no sense.
        let result = fetch(this.feedJsonEndpoint, {
            method: 'GET',
            headers: {
                'content-type': 'application/json',
            },
            mode: 'cors'
        });
        let obj = null;
        if(result.status == 200) {
            obj = await result.json();
        }
        console.log(obj);
        */
       //#endregion
        
       let obj = await new Promise((function(resolve) {
            var xobj = new XMLHttpRequest();
            xobj.overrideMimeType("application/json");
            xobj.open('GET', cdn + 'video-widget/' + widgetCode + '/feed-data.json', true);
            xobj.onreadystatechange = function () {
                if (xobj.readyState == 4 && xobj.status == "200") {
                    resolve(new VideoWidget(JSON.parse(xobj.responseText)));
                }
            };
            xobj.send(null);
        }).bind(this));
        obj.widget_code = widgetCode;
        obj.cdn = cdn;
        return obj;
    }
    //#endregion
}

class Author extends BaseModel {
    first_name = null;
    last_name = null;
    id = null;
    image = null;
    job_title = null;
    constructor(jsonObj) {
        super();
        this.init(jsonObj);
    }


}


class TagType extends BaseModel {
    uuid = null;
    tag_type_name = null;
    active = null;
    company_public_id = null;
    widget_code = null;
    tags_collection = null;
    usage_count = null;

    constructor(jsonObj) {
        super();
        this.init(jsonObj);
    }

    //#region Init Handlers
    initHandlers() {
        return {
            tags_collection: TagType._tagsInitHandler,
        }
    }


    static _tagsInitHandler(tags) {
        let newTags = [];
        for(var key in tags) {
            let tag = new Tag(tags[key]);
            HandlebarsCache.Instance.addToCache('tag', tag.id, tag)
            newTags.push(tag);
        }
        return newTags;
    }

    //#endregion
}

class Tag extends BaseModel {
    active = null;
    company_public_id = null;
    tag_name = null;
    tag_type_uuid = null;
    usage_count = null;
    uuid = null;

    constructor(jsonObj) {
        super();
        this.init(jsonObj);
    }
}

class VideoWidgetPost extends BaseModel {
    id = null;
    thumbnail_link = null;
    gif_link = null;
    autoplay_gif_link = null;
    video_title = null;
    video_description = null;
    video_share_type = null;
    video_streams = null;
    video_subtitles = null;
    button_cta = null;
    button_cta_link = null;
    button_cta_fallback = null;
    category_id = null;
    category_name = null;
    category_color = null;
    user = null;
    assigned_user_id = null;
    tag_uuids = null;

    tags = null;

    constructor(jsonObj) {
        super();
        this.init(jsonObj);
    }
    
    //#region Init Handlers
    initHandlers() {
        return {
            user: VideoWidgetPost._userInitHandler,
        }
    }


    static _userInitHandler(obj) {
        return new Author(obj);
    }

    _rendered_tags = null;
    // Property that is actually a function
    rendered_tags = function() {
        if(this._rendered_tags != null) {
            return this._rendered_tags;
        }
        if(this.tags == null) {
            return this._rendered_tags;
        }
        this._rendered_tags = [];
        var charCount = 0;
        let didBreak = false;
        for(var key in this.tags) {
            for(var i = 0;i < this.tags[key].tags_collection.length;i++) {
                let _tag = this.tags[key].tags_collection[i];
                charCount += _tag.tag_name.length;
                if(charCount < 50 && this._rendered_tags.length < 4) {
                    this._rendered_tags.push(_tag);
                } else {
                    this._rendered_tags.push(new Tag({
                        uuid:"vmj-widget-tag-others",
                        tag_name: "+"+(this._tags_length - this._rendered_tags.length)+" others"
                    }));
                    didBreak = true;
                    break;
                }
            }
            if(didBreak) {
                break;
            }
        }
        return this._rendered_tags;
    }

    _tags_length = 0;
    generateTagData(tags) {
        this.tags = {};
        for(var tagTypeKey in this.tag_uuids) {
            // Clone the tag type, this is because the tag types will contain different tags depending on what tags are used
            let _clonedTag = structuredClone(tags[tagTypeKey]);
            // the list of tag uuids for this video
            let _tags = this.tag_uuids[tagTypeKey];
            // reset the cloned tag types tags list
            _clonedTag.tags_collection = tags[tagTypeKey].tags_collection.filter((t) => { return _tags.includes(t.uuid)});
            this.tags[_clonedTag.uuid] = _clonedTag;
            this._tags_length += _clonedTag.tags_collection.length;
        }
    }

    _tag_classes = null;
    tagClasses = function() {
        if(this._tag_classes != null) {
            return this._tag_classes;
        }
        let classes = [];
        for(var key in this.tag_uuids) {
            for(var i = 0;i < this.tag_uuids[key].length;i++) {
                classes.push("tag-" + this.tag_uuids[key][i])
            }
        }
        this._tag_classes = classes.join(' ');
        return this._tag_classes;
    }

    //#endregion
}